import { Component, OnInit } from '@angular/core';
import { CreditBalanceViewDto } from '@marketplace/api';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { CreditBalanceService } from '@features/account/modules/payment/services';

@Component({
    selector: 'marketplace-checkout',
    templateUrl: './checkout.container.html',
    styleUrls: ['./checkout.container.scss'],
    standalone: false
})
export class CheckoutContainer implements OnInit {
  public gridSize: string = environment.gridSize;
  public creditBalance$: Observable<CreditBalanceViewDto>;

  constructor(private _creditBalanceService: CreditBalanceService) {}

  ngOnInit() {
    this.creditBalance$ = this._creditBalanceService.getCreditBalance$();
  }
}
